var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTelegramFooter = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18485_2545)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0.485352H0V40.4854H40V0.485352ZM27.4139 29.1497L31.6844 10.4956L31.6848 10.4956C31.9444 9.3686 30.8724 8.41895 29.876 8.88051L9.06769 18.4913C8.04626 18.9615 8.00439 20.4791 8.99237 21.0205L13.2126 23.3278L25.7728 14.0629C25.9066 13.9655 26.0406 14.0807 26.049 14.2139L15.5233 24.8632C15.2637 25.1294 15.1131 25.4933 15.1131 25.8748V30.8091C15.1131 32.2203 16.8715 32.7438 17.5664 31.5369L20.1203 27.1086L25.5214 30.0636C26.2835 30.4808 27.213 30.0282 27.4139 29.1497Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18485_2545"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.485352,
    width: 40,
    height: 40,
    rx: 5.51724,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTelegramFooter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/telegram-footer.6c29fab2.svg";
export { ForwardRef as ReactComponent };